import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import RefinementItem from 'components/BeautyPreferencesWorld/RefinementItem/RefinementItem';
import { Grid } from 'components/ui';

function RefinementItemsDisplay({
    refinementDisplayType,
    refinementItems = [],
    smallDisplayColumns,
    largeDisplayColumns,
    onRefinementItemClick,
    refinementItemsSelected = [],
    children,
    refinement,
    noToggle = false
}) {
    const columns =
        refinement?.selectionType === 'SEARCHABLE'
            ? ['repeat(2, 1fr)', 'repeat(4,1fr)']
            : [`repeat(${smallDisplayColumns ?? 3}, 1fr)`, `repeat(${largeDisplayColumns ?? 3}, 1fr)`];

    return (
        <Grid
            data-no-toggle={`${Boolean(noToggle)}`}
            columns={columns}
        >
            {refinementItems.map(refinementItem => (
                <RefinementItem
                    refinement={refinement}
                    key={refinementItem.key}
                    refinementItem={refinementItem}
                    displayType={refinementDisplayType}
                    onRefinementItemClick={e => onRefinementItemClick?.(e, refinementItem)}
                    isSelected={refinementItemsSelected.includes(refinementItem.key)}
                />
            ))}
            {children}
        </Grid>
    );
}

export default wrapFunctionalComponent(RefinementItemsDisplay, 'RefinementItemsDisplay');
